export default __webpack_public_path__ + "static/media/spark_45.8874cf4b.png";